import { Text } from '@thanx/uikit/text'
import HelpLink from 'components/HelpLink'
import { buildTranslate } from 'locales'
import { ContentBlockData } from 'slices/appLandingPageTheme/types'
import AudienceSection from './AudienceSection'
import AvailabilitySection from './AvailabilitySection'

type Props = {
  blockId: string
  contentBlock: ContentBlockData
  updateContentBlock: (blockId: string, data: any) => void
}

const t = buildTranslate(
  'cms.content.app_home_page.content.edit_block.configuration'
)

const Configuration = ({
  blockId,
  contentBlock,
  updateContentBlock,
}: Props) => {
  const {
    audience_type,
    availability_type,
    segment_id,
    target_segments,
    start_at,
    end_at,
  } = contentBlock
  const audienceType = audience_type || 'all_customers'
  const availabilityType = availability_type || 'always_available'

  // Handle segment ID (could come from backend as target_segments array or UI as segment_id)
  let selectedSegmentId: number | undefined = undefined
  if (
    target_segments &&
    Array.isArray(target_segments) &&
    target_segments.length > 0
  ) {
    const segmentId = Number(target_segments[0])
    selectedSegmentId = Number.isNaN(segmentId) ? undefined : segmentId
  } else if (segment_id) {
    const segmentId = Number(segment_id)
    selectedSegmentId = Number.isNaN(segmentId) ? undefined : segmentId
  }

  // Handle temporal fields - use combined datetime format
  const showStartDate = Boolean(start_at)
  const showEndDate = Boolean(end_at)

  return (
    <div>
      <Text.Header3 className="mb-l">{t('title')}</Text.Header3>

      <AudienceSection
        blockId={blockId}
        audienceType={audienceType}
        selectedSegmentId={selectedSegmentId}
        updateContentBlock={updateContentBlock}
      />

      <AvailabilitySection
        blockId={blockId}
        availabilityType={availabilityType}
        showStartDate={showStartDate}
        showEndDate={showEndDate}
        startAt={start_at}
        endAt={end_at}
        updateContentBlock={updateContentBlock}
      />

      <div className="mt-xl">
        <HelpLink url="https://help.thanx.com/hc/en-us/articles/21256439661975-Customizable-app-home-page">
          Learn more about configuration options
        </HelpLink>
      </div>
    </div>
  )
}

export default Configuration
